
Monet.Session = Monet.Session || {};

Monet.Validators = {
    isEmail: function (email) {
        if (!email) {
            return true;
        }

        var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return email.search(emailRegex) !== -1;
    },


    isNumeric: function (numero) {

        if (!numero) {
            return true;
        }

        var numeroRegex = /^[0-9]+$/;
        return numero.search(numeroRegex) !== -1;
    },

    isURL: function (url) {
        var urlRegex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return url.search(urlRegex) !== -1;
    },

    isPhone: function (phone) {
        const phoneRegex = /^(\+[0-9]+)?( ?\([0-9]+\))?([ |-]?[0-9]+)+$/;
        return phone.search(phoneRegex) !== -1 || !phone;
    }
};

Monet.navigation = {
    goTo: function (entity, action) {
        window.location = "#/" + entity + "/" + action;
    },
    openChild: function (e) {
      const tab = window.GreenmileTabPanel.getActiveTab();
      const model = App.Forms[tab].form.getModel();
      const entity = document.querySelector(`#${e}`).getAttribute('entity');
      if(entity === 'LocationOverrideTimeWindow') {
        App.Objects.LocationOverrideTimeWindow.setParentId(model.id);
      }
      window.location = `#/${tab}/${model.id}/${entity}`;
    }
};

/*
 * Controla o cache dos JSONs que descrevem os layouts dos formulários
 * @params {object} entity: A entidade a qual esse formulário faz referência
 * @params {string} crudStation: Em que etapa o cadastro está, pode ser list, new e edit
 *
 */

Monet.Cache = {

    check: function (settings) {

        if (settings !== undefined) {
            this.settings = settings;
        } else {
            return false;
        }

        var that = this;
        var crudStation = that.settings.crudStation;

        Monet.DataMapper.checkNameSpace(this.settings.entity, ["layout", crudStation], function () {

            var layoutCrudStage = App.Forms[that.settings.entity].layout[that.settings.crudStation];

            if ((!layoutCrudStage || Object.keys(layoutCrudStage).length === 0)  && that.settings.notcached) {
                that.settings.notcached(that.settings.entity);
            } else {
                if(that.settings.cached) {
                    that.settings.cached(that.settings.entity);
                }
            }
        });
    }
};

Monet.DataMapper = {
    map: {},
    push: function (field, value) {
        this.map[field] = value;
    },
    checkNameSpace: function (entity, group, callback_f) {
        if (!App.Forms[entity]) {
            App.Forms[entity] = {};
        }

        $.each(group, function (i, space) {
            if (i !== group.length - 1) {
                if (i > 0) {
                    if (App.Forms[entity][group[i - 1]][space] === undefined) {
                        App.Forms[entity][group[i - 1]][space] = {};
                    }
                } else {
                    if (App.Forms[entity][space] === undefined) {
                        App.Forms[entity][space] = {};
                    }
                }
            } else {
                if (i > 0) {
                    if (App.Forms[entity][group[i - 1]][space] === undefined) {
                        App.Forms[entity][group[i - 1]][space] = "";
                    }
                } else {
                    if (App.Forms[entity][space] === undefined) {
                        App.Forms[entity][space] = "";
                    }
                }
            }
        });

        callback_f();
    }
};

Monet.Toast = {
    // Type do toast
    inlineToast: function (type, message, delayTime) {

        $.toast({
            message: message,
            displayTime: delayTime,
            inTime: 100,
            outTime: 400,
            vPosition: "center",
            hPosition: "center",
            className: type
        });
    },

    typeToast: function () {

        var obj = {
            alert: "toast toastAlert",
            info: "toast toastInfo"
        };

        return obj;
    }
};

/**
 * Faz a checagem de novas atualizações que ocorrem na página de maps
 *
 */

Monet.CheckerUpdate = {};

Monet.projectionBuilder = function (dataMapper, paginationNameSpace, columnsToOrders) {

    var projection = {
        filters: ['id'],
        orders: [],
        firstResult: 0,
        maxResults: 51
    };

    var mapKeys = [];

    for (var field in dataMapper) {
        if (dataMapper[field].type !== "LINK") {
            mapKeys.push(field);
        }
    }

    for (var key = 0, l = mapKeys.length; key < l; key++) {

        if (typeof mapKeys[key] === "string") {

            var tempoStringKey = mapKeys[key];

            if (dataMapper[mapKeys[key]] && dataMapper[mapKeys[key]].lookupEntity) {
                tempoStringKey += '.*';
            }

            projection.filters.push(tempoStringKey);

        }

    }

    if (columnsToOrders) {
        for (var order = 0, colIndex = columnsToOrders.length; order < colIndex; order++) {
            projection.orders.push({
                attr: columnsToOrders[order].field,
                type: columnsToOrders[order].order
            });
        }
    }

    if (paginationNameSpace) {
        projection.firstResult = paginationNameSpace.first;
        projection.maxResults = paginationNameSpace.max;
    }

    return JSON.stringify(projection);

};

Monet.Backgrounder = function (initialFunc) {

    this.timeout = null;

    this.schedule = function (func) {
        var self = this;
        this.timeout = setTimeout(function () {
            self.execute(func);
        }, 0);
    };

    this.execute = function (func) {
        this.timeout = null;
        if (!this.aborted) {
            func();
        }
    };

    this.interrupt = function () {
        clearTimeout(this.timeout);
        this.timeout = null;
    };

    this.finished = function () {
        this.abort();
    };

    if (initialFunc !== undefined) {
        initialFunc(this);
    }

};

Monet.Utils = {};
Monet.Utils.GetTabName = function () {
  let tabName = window.GreenmileTabPanel.getActiveTab();
  if (tabName === 'TrackEquipmentMapsDisplay') {
    tabName = 'TrackEquipmentMaps';
  }
  return tabName;
};

Monet.Utils.GetTabsList = function () {
    return window.GreenmileTabPanel.props.tabs.get('list');
};

Monet.Utils.sortComparator = function(a,b) {

    if (a.name < b.name) {
        return -1;
    } else if (a.name > b.name) {
        return 1;
    }

    return 0;
};

Monet.Utils.getHeightDefaultToTab = function() {

    let heightDefault = 0;
    let heightNotification = 0;
    const heightMenu = parseInt($(".navbar-inner").height(), 10);
    const heightTabs = parseInt($(".ui-tabs").height(), 10);
    const top = parseInt($(window).height(), 10) / 2;

    if ($(".detailErrorException").attr("visible") === "true") {
        heightNotification = parseInt($(".detailErrorException").css("height"), 10);
    }

    heightDefault = top - heightMenu - heightTabs - heightNotification + 7;

    return heightDefault;

};

Monet.Utils.CriteriaMatchModes = {

    EXACT: 'EXACT',
    ANYWHERE: 'ANYWHERE',
    START: 'START',
    END: 'END'

};

Monet.Security = {

    initializeNamespace: function () {
        Monet.Session = Monet.Session || {};
        Monet.Session.Security = Monet.Session.Security || {};
    },
    setScreensEnabledByMenu: (menus) => {

      Monet.Session = Monet.Session || {};
      Monet.Session.Security = Monet.Session.Security || {};
      Monet.Session.Security.screens = Monet.Session.Security.screens || ['/AccessDenied/401', '/Panel', '/maps', '/help_releasenotes', '/RouteMonitor'];

      const checkPermissions = (url) => {
        const checkGreenmileUtils = () => {
            !Greenmile.Utils && window.location.reload();
        };

        if (url === "#/ProactiveRouteOptConfig"){
            checkGreenmileUtils();
            return Greenmile.Utils.hasPermission("PRO");
        }

        return true;
      }

      const accumulator = (acc, item) => {
        if (item.submenus && item.submenus.length) {
          return item.submenus.reduce(accumulator, acc);
        } else if (item.url !== '#/') {
            let value = item.url;
            if(item.url === '#/welcome') {
                value = '#/RouteMonitor';
                acc.push('/RouteSuggestion');
            }
            if (checkPermissions(item.url))  acc.push(value.replace('#', ''));
        }
        return acc;
      };
      Monet.Session.Security.screens = Monet.Session.Security.screens.concat(menus.reduce(accumulator, []));
    },
    /**
     *
     * @param keyPermissions Array
     */

    checkKeyIsEnabled: function (keyPermissions) {

      Monet.Session.Security = Monet.Session.Security || {};
      const permissions = Monet.Session.Security.permissions;

      if (keyPermissions && permissions) {
        const result = keyPermissions.some(key =>
          permissions.some(permission => permission.key === key)
        );
        return result;
      }
      return false;
    },

    getKeys: function (propertie) {
        var keys = [];
        switch (propertie) {
            case "TimeWindowType":
                keys.push('TIMEWINDOWTYPEDAYS_LIST');
                keys.push('TIMEWINDOWTYPEDAYS_CREATE');
                keys.push('TIMEWINDOWTYPEDAYS_UPDATE');
                keys.push('TIMEWINDOWTYPEDAYS_DELETE');

                return keys;

            case "Location":
                keys.push('LOCATIONOVERRIDETIMEWINDOW_LIST');
                keys.push('LOCATIONOVERRIDETIMEWINDOW_CREATE');
                keys.push('LOCATIONOVERRIDETIMEWINDOW_UPDATE');
                keys.push('LOCATIONOVERRIDETIMEWINDOW_DELETE');

                return keys;

            case "HoursOfServiceType":
                keys.push('HOURSOFSERVICETYPEDAYS_LIST');
                keys.push('HOURSOFSERVICETYPEDAYS_CREATE');
                keys.push('HOURSOFSERVICETYPEDAYS_UPDATE');
                keys.push('HOURSOFSERVICETYPEDAYS_DELETE');

                return keys;

            default:
                return [];
        }
    }

};


/**
 * Classes de tratamento de erro do Monet.
 *
 */

Monet.Exception = {};
Monet.Exception.Base = function (closure, message, exception) {

    this.closure = closure;
    this.message = message;
    this.exception = exception;

    this.errorObj = {
        "closure": this.closure,
        "message": this.message,
        "exception": this.exception
    };

};

Monet.Exception.ReturnError = (function () {

    function ReturnError() {

        Monet.Exception.Base.apply(this, arguments);

        this.console = function () {

            if (!this.errorObj) {
                return false;
            } else {
                const error1 = (this.errorObj.message || this.errorObj.exception);
                const error2 = this.errorObj.exception !== error1 && this.errorObj.exception;
                const template1 = error1 ? ('·%c ' + error1) : '%c';
                const template2 = error2 ? ('\n' + error2) : '';
                console.error(`%cMonet Exception ${template1} ${template2}`, 'font-weight: bold', 'font-weight: normal');
            }

        };

        this.returnObj = function () {

            if (!this.errorObj) {
                return false;
            } else {
                return this.errorObj;
            }

        };

    }

    ReturnError.prototype = new Monet.Exception.Base();

    return ReturnError;

})();
